import { render, staticRenderFns } from "./ModelSelect.vue?vue&type=template&id=5374d1f6&scoped=true&"
import script from "./ModelSelect.vue?vue&type=script&lang=js&"
export * from "./ModelSelect.vue?vue&type=script&lang=js&"
import style0 from "./ModelSelect.vue?vue&type=style&index=0&id=5374d1f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5374d1f6",
  null
  
)

export default component.exports